(function(ng, $) {
    //service that manages the current user's cart
    //binds to ~/cart/ endpoint

    ng.module('evo.Packages.Services').factory('cartService',
        [
            '$http', 'CART_SERVICE_BASE',
            function($http, CART_SERVICE_BASE) {
                return {
                    addItems: function(selectedItems) {
                        /// <summary>
                        ///     Adds the given items to the current user's cart
                        /// </summary>
                        /// <param name="selectedItems" type="Array">items to add</param>
                        /// <returns type="Object">Returns the task (deferred)</returns>
                        return $http.post(CART_SERVICE_BASE, (selectedItems || []));
                    }
                };
            }
        ]);
})(angular, jQuery);